<template>
  <div class="chips-container">
    <div class="content">
      <div class="dropdown-content">
        <v-autocomplete class="dropdown"
        clearable
        dense
        filled
        rounded
        auto-select-first
        v-model="selectedDropDownValue"
        :items="contentData.responses.data"
        :item-value="item=>item.id"
        item-text="displayName"
        :no-data-text="contentData.responses.notFoundText"
        :placeholder="contentData.responses.text"
      ></v-autocomplete>
      </div>
    </div>
    <div class="btns-wrap">
      <v-btn depressed block class="primary-txt-btn __h68" :disabled="selectedDropDownValue === null" @click="submitAnswer(true)">{{
        contentData.responses.submitbutton
      }}</v-btn>
      <v-btn
        depressed
        block
        class="grey-txt-btn __h68"
        @click="submitAnswer(false)"
        v-show="!contentData.hideCancelbutton"
        >{{ contentData.responses.cancelbutton }}</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentData: {
        responses: {
          text: "placeholder text",
          notFoundText: "not found text",
          submitbutton: "submit",
          cancelbutton: "cancel",
          data: [
            {
              id: "A",
              displayName: "Human Reable Entry 1",
            },
            {
              id: "B",
              displayName: "Human Reable Entry 2",
            },
          ],
        },
        hideCancelbutton: false,
      },
      selectedDropDownValue: null,
    }
  },
  methods: {
    // NOTE: Dropdown entries are treated exactly the same as Textbox entries!
    // TODO: this function is identical to Textbox => Therefore can be merged in future 
    submitAnswer(answered) {
      let newInput = {}
      if (answered === true) {
        newInput = {
          dropdown: {
            enteredText: this.$data.selectedDropDownValue,
            skipped: false,
          },
        }
      } else {
        newInput = {
          dropdown: {
            skipped: true,
          },
        }
      }
      console.log(newInput)
      this.$emit("submitAnswer", newInput)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for DropDown Card")

      let updatedContent = {
        responses: {
          text: executableSystemAction.guiTemplateContent.dropdown.text,
          notFoundText: executableSystemAction.guiTemplateContent.dropdown.notFoundText,
          submitbutton: executableSystemAction.guiTemplateContent.submitbutton.text,
          cancelbutton: executableSystemAction.guiTemplateContent.cancelbutton.text,
          data: executableSystemAction.guiTemplateContent.dropdown.data
        },
        hideCancelbutton: executableSystemAction.guiTemplateContent.cancelbutton.hidden,
      }
      this.contentData = updatedContent
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>

<style></style>
